const Team = () => import(/* webpackChunkName: "gt-members" */'@/components/Team/Index')
const TeamVideo = () => import(/* webpackChunkName: "gt-members-view" */'@/components/Team/TeamVideo')
const TeamMember = () => import(/* webpackChunkName: "gt-members-view" */'@/components/Team/TeamMember')

export default [
    {
        path: '/connect-with-us/',
        component: Team,
        children: [{

            path: '/',
            name: 'connect',
            component: TeamVideo

        }, {

            path: ':slug',
            name: 'member',
            props: true,
            component: TeamMember
        }]
    }
]